import './Hero.css';
import heroImage from '../../assets/hero-led.jpg';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    document.querySelector(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content" data-aos="fade-right">
          <h1>Painéis de LED para Eventos Incríveis</h1>
          <p>Aumente o impacto visual e a visibilidade do seu evento com nossos painéis de LED de alta qualidade. Crie experiências memoráveis com iluminação profissional e displays personalizados.</p>
          <div className="hero-buttons">
            <button 
              className="button-primary" 
              onClick={() => scrollToSection('#hero-info')}
            >
              Saiba Mais
            </button>
            <button 
              className="button-secondary" 
              onClick={() => scrollToSection('#contato')}
            >
              Entre em Contato
            </button>
          </div>
        </div>
        <div className="hero-image" data-aos="fade-left">
          <img src={heroImage} alt="Painel de LED em evento" />
        </div>
      </div>
    </section>
  );
};

export default Hero; 
